<template>
  <a-drawer
    style="z-index: 999;"
    placement="right"
    width="600"
    :closable="false"
    @close="onClose"
    :visible="visible"
  >
    <div slot="title">
      <span>查看客户信息</span>
      <div style="float: right">
        <a-button v-if="!editDivVisible" @click="openEditDiv">编辑</a-button>
        <a-button v-if="!editDivVisible" style="margin-left: 10px;" type="primary" @click="handlePay">续费</a-button>
      </div>
    </div>
    <div v-if="loading" style="text-align:center"><a-spin/></div>
    <div style="margin-left:10px" v-if="!loading && !editDivVisible">
      <a-divider orientation="left">账号信息</a-divider>
      <detail-list size="small" :col="1">
        <!-- <detail-list-item term="客户ID">{{ viewDetailData.tenant_id }}</detail-list-item> -->
        <detail-list-item term="客户名称">{{ viewDetailData.name }}</detail-list-item>
        <detail-list-item term="客户编码">{{ viewDetailData.code }}</detail-list-item>
        <detail-list-item term="联系人">{{ viewDetailData.contacts }}</detail-list-item>
        <detail-list-item term="联系人电话">{{ viewDetailData.contact_number }}</detail-list-item>
        <detail-list-item term="登陆账号">{{ viewDetailData.admin_account }}</detail-list-item>
        <detail-list-item term="会员类型">{{ viewDetailData.code_type | valInDict(dict.codeTypeDict) }}</detail-list-item>
        <detail-list-item term="状态">{{ viewDetailData.status | valInDict(dict.statusDict) }}</detail-list-item>
        <detail-list-item term="云码数量">{{ viewDetailData.security_code_balance }}</detail-list-item>
        <detail-list-item term="开通时间">{{ viewDetailData.effect_time }}</detail-list-item>
        <detail-list-item term="到期时间">{{ viewDetailData.expiry_time }}</detail-list-item>
        <detail-list-item term="业务经理">{{ viewDetailData.business_manager || '--' }}</detail-list-item>
        <detail-list-item term="开通服务">{{ viewDetailData.service_str || '--' }}</detail-list-item>
      </detail-list>
      <a-divider orientation="left">企业信息</a-divider>
      <detail-list size="small" :col="1">
        <detail-list-item term="企业全称">{{ viewDetailData.company_info.system_name }}</detail-list-item>
        <detail-list-item term="企业简称">{{ viewDetailData.company_info.system_short_name }}</detail-list-item>
        <detail-list-item term="企业Logo"><img :src="viewDetailData.company_info.system_logo" style="width:100px;" alt="LOGO" /></detail-list-item>
        <detail-list-item term="官网地址">{{ viewDetailData.company_info.system_url }}</detail-list-item>
        <detail-list-item term="联系电话">{{ viewDetailData.company_info.phone }}</detail-list-item>
        <detail-list-item term="联系QQ">{{ viewDetailData.company_info.qq_number }}</detail-list-item>
        <detail-list-item term="联系邮箱">{{ viewDetailData.company_info.email }}</detail-list-item>
        <detail-list-item term="联系地址">{{ viewDetailData.company_info.address }}</detail-list-item>
      </detail-list>
    </div>
    <!-- 编辑div -->
    <editDiv
      v-if="editDivVisible"
      :visible="editDivVisible"
      :tenantId="id"
      :tenantDetail="viewDetailData"
      @hide="cancelEditDiv"
      @finish="finishEdit"/>
  </a-drawer>
</template>
<script>
import { getPre, getTenantDetail } from '@/api/tenant'
import _ from 'lodash'
import DetailList from '@/components/DescriptionList'
import editDiv from './editDiv'

const DetailListItem = DetailList.Item
export default {
  components: {
    DetailListItem,
    DetailList,
    editDiv
  },
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    id: {
      type: Number,
      default: 0
    }
  },
  data () {
    return {
      // 抽屉加载
      loading: true,
      // 基本信息
      viewDetailData: {},
      // 编辑div状态开关
      editDivVisible: false,
      dict: {}
    }
  },
  methods: {
    handelPre () {
      getPre().then(res => {
        if (_.get(res, 'code') === 200) {
          this.dict = _.get(res, 'values', {})
        }
      })
    },
    // 关闭抽屉
    onClose () {
      this.$emit('hide')
    },
    // 完成编辑
    finishEdit () {
      this.editDivVisible = false
      this.getDetail()
      this.$emit('finish')
    },
    // 切换编辑div
    openEditDiv () {
      this.editDivVisible = true
    },
    // 关闭编辑div
    cancelEditDiv () {
      this.editDivVisible = false
    },
    handlePay () {
      this.$emit('handlePay')
    },
    // 加载数据详情
    getDetail () {
      this.loading = true
      console.log(this.id)
      getTenantDetail(this.id).then(res => {
        if (_.get(res, 'code') === 200) {
          this.viewDetailData = _.get(res, 'data', {})
          this.loading = false
        }
      })
    }
  },
  created () {
    this.handelPre()
    this.getDetail()
  }
}
</script>
